import React, { useState } from 'react';
import { Card, Button, message } from 'antd';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { Axios } from '../../../../Api/Axios';
import { OFFERS } from '../../../../Api/Api';
import styles from './payment.module.css';

const stripePromise = loadStripe(
  "pk_test_51RHgyIP4KE97EU0Rnp35ejhd2isQhpE6pBsxsdtzUKnlwTwtxVFtX3VpQkmIesCGcoUBCSc24rHURSr9NY3eHmRX003M7Pcj8l"
);

const PaymentForm = ({ offer, onSuccess }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const defaultProfileImage = require("../../../../Assets/Images/profile.jpg");

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe || !elements) {
      return;
    }
    setLoading(true);
    try {
      // Create a checkout session
      const response = await Axios.post(
        `${OFFERS}/${offer.id}/create-payment-session`,
        {
          amount: offer.amount,
          offer_id: offer.id,
        }
      );
      // Redirect to Stripe Checkout
      const { error } = await stripe.redirectToCheckout({
        sessionId: response.data.sessionId,
      });
      if (error) {
        message.error(error.message);
      } else {
        onSuccess();
      }
    } catch (error) {
      message.error('Payment failed. Please try again.');
      console.error('Error:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className={styles.paymentForm}>
      <div className={styles.paymentDetails}>
        <h3>Payment Details</h3>
        <div className={styles.talentInfo}>
          <img 
            src={offer.talent.profilePicture ? `data:image/jpeg;base64,${offer.talent.profilePicture}` : defaultProfileImage} 
            alt={offer.talent.name}
            className={styles.talentImage}
          />
          <div className={styles.talentDetails}>
            <h4>{offer.talent.name}</h4>
            <p className={styles.amount}>${offer.amount}</p>
          </div>
        </div>
      </div>

      <div className={styles.cardElementContainer}>
        <CardElement
          options={{
            style: {
              base: {
                fontSize: '16px',
                color: '#424770',
                '::placeholder': {
                  color: '#aab7c4',
                },
              },
              invalid: {
                color: '#9e2146',
              },
            },
          }}
        />
      </div>

      <Button
        type="primary"
        htmlType="submit"
        loading={loading}
        disabled={!stripe}
        className={styles.payButton}
      >
        {loading ? 'Processing...' : `Pay $${offer.amount}`}
      </Button>

      <div className={styles.paymentSecurity}>
        <p>🔒 Your payment information is secure</p>
        <p>Powered by Stripe</p>
      </div>
    </form>
  );
};

const Payment = ({ offer, onSuccess }) => {
  return (
    <div className={styles.paymentContainer}>
      <Card className={styles.paymentCard}>
        <Elements stripe={stripePromise}>
          <PaymentForm offer={offer} onSuccess={onSuccess} />
        </Elements>
      </Card>
    </div>
  );
};

export default Payment;